/**
 * Steps of the TOTP (Two-Factor Authentication) setup and management flow.
 * Used by TotpForm and can be referenced where the flow state is needed.
 */
export enum TotpStepEnum {
  Loading = 'loading',
  Status = 'status',
  Setup = 'setup',
  Verify = 'verify',
  BackupCodes = 'backup-codes',
  RegenerateCodes = 'regenerate-codes',
  RegenerateVerify = 'regenerate-verify',
  DisableVerify = 'disable-verify',
}
